export default __webpack_public_path__ + "static/media/gallery_03.ae4bc3b0.jpg";